<template>
  <dx-counterparty-form
    next-step-path="PartnerPortal-ReportDamage-ThankYou"
    previous-step-path="PartnerPortal-ReportDamage-Deadline"
    :is-broker="true"
    create-claim-action="createBrokerLegalClaim"
  />
</template>

<script>
import DxCounterpartyForm from '~/components/reportDamage/DX-CounterpartyForm'

export default {
  name: 'PartnerReportDamageCounterparty',
  components: {
    DxCounterpartyForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/schaden-melden/gegenpartei',
      fr: '/portailpartenaires/dommages-rapport/contrepartie',
      it: '/portaledeipartner/danni-report/controparte',
    },
  },
}
</script>
